/* ==========================================================
   EVERDEN - BUNDLE TIER SELECTOR
   Turns the "Pack" variant option into priced tier cards.
   Prices are read live from the product JSON, so editing
   prices in Shopify updates this UI automatically.
   ========================================================== */

(function () {
  "use strict";

  var COPY = {
    "1-Pack": {
      name: "One brush",
      sub: "For a single pet"
    },
    "2-Pack": {
      name: "Two brushes",
      sub: "One for home, one for the car",
      flag: "Most popular"
    },
    "3-Pack": {
      name: "Three brushes",
      sub: "For multi-pet homes or gifting",
      flag: "Best value",
      flagClass: "everden-tier__flag--value"
    }
  };

  var LEGEND = "Choose your set";
  var priceData = null;
  var variantsById = null;
  var lastStickyWrite = "";

  function money(pence) {
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      "GBP";
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency
      }).format(pence / 100);
    } catch (e) {
      return "£" + (pence / 100).toFixed(2);
    }
  }

  function qtyFromValue(value) {
    var m = String(value).match(/^(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  /* ---- pull prices from the live product JSON ---- */

  function fetchPrices() {
    if (priceData) return Promise.resolve(priceData);

    var path = window.location.pathname.split("?")[0].replace(/\/$/, "");
    if (path.indexOf("/products/") === -1) return Promise.resolve(null);

    return fetch(path + ".js", { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (product) {
        if (!product || !product.variants) return null;

        var names = (product.options || []).map(function (o) {
          return typeof o === "string" ? o : o.name;
        });
        var idx = names.indexOf("Pack");
        if (idx === -1) return null;

        var byPack = {};
        var byId = {};
        product.variants.forEach(function (v) {
          byId[String(v.id)] = {
            price: v.price,
            compareAt: v.compare_at_price || null
          };
          var value = v.options && v.options[idx];
          if (!value || byPack[value]) return;
          byPack[value] = {
            price: v.price,
            compareAt: v.compare_at_price || null
          };
        });

        priceData = byPack;
        variantsById = byId;
        return byPack;
      })
      .catch(function () {
        return null;
      });
  }

  /* ---- build one tier card ---- */

  function decorate(input, container, prices) {
    var value = input.value;
    var copy = COPY[value] || { name: value, sub: "" };
    var qty = qtyFromValue(value);

    var label = container.querySelector("label");
    if (!label) return;

    var forId = label.getAttribute("for");
    label.innerHTML = "";
    if (forId) label.setAttribute("for", forId);

    /* flag */
    if (copy.flag) {
      var flag = document.createElement("span");
      flag.className =
        "everden-tier__flag" + (copy.flagClass ? " " + copy.flagClass : "");
      flag.textContent = copy.flag;
      label.appendChild(flag);
    }

    /* radio dot */
    var dot = document.createElement("span");
    dot.className = "everden-tier__dot";
    dot.setAttribute("aria-hidden", "true");
    label.appendChild(dot);

    /* text block */
    var text = document.createElement("span");
    text.className = "everden-tier__text";

    var name = document.createElement("span");
    name.className = "everden-tier__name";
    name.textContent = copy.name;
    text.appendChild(name);

    if (copy.sub) {
      var sub = document.createElement("span");
      sub.className = "everden-tier__sub";
      sub.textContent = copy.sub;
      text.appendChild(sub);
    }

    var tier = prices && prices[value];
    var single = prices && prices["1-Pack"];
    if (tier && single && qty > 1) {
      var saving = single.price * qty - tier.price;
      if (saving > 0) {
        var save = document.createElement("span");
        save.className = "everden-tier__save";
        save.textContent = "Save " + money(saving);
        text.appendChild(save);
      }
    }

    label.appendChild(text);

    /* price block */
    var priceWrap = document.createElement("span");
    priceWrap.className = "everden-tier__price";

    if (tier) {
      var now = document.createElement("span");
      now.className = "everden-tier__now";
      now.textContent = money(tier.price);
      priceWrap.appendChild(now);

      if (tier.compareAt && tier.compareAt > tier.price) {
        var was = document.createElement("span");
        was.className = "everden-tier__was";
        was.textContent = money(tier.compareAt);
        priceWrap.appendChild(was);
      }

      if (qty > 1) {
        var each = document.createElement("span");
        each.className = "everden-tier__each";
        each.textContent = money(Math.round(tier.price / qty)) + " each";
        priceWrap.appendChild(each);
      }
    }

    label.appendChild(priceWrap);

    /* screen readers still need the plain option name */
    var sr = document.createElement("span");
    sr.className = "visually-hidden";
    sr.textContent = value;
    label.appendChild(sr);
  }

  /* ---- keep the sticky add-to-cart price in sync ----
     The Atlas sticky bar renders its own price block and does not
     refresh it when the variant changes, so it would otherwise show
     the 1-Pack price while a 2 or 3-Pack is selected. */

  function syncSticky() {
    if (!variantsById) return;

    var block = document.querySelector(".sticky-atc__price");
    if (!block) return;

    var idInput = document.querySelector('input[name="id"]');
    var variant = idInput && variantsById[String(idInput.value)];
    if (!variant) return;

    var now = money(variant.price);
    var was = variant.compareAt ? money(variant.compareAt) : null;
    var stamp = now + "|" + was;
    if (stamp === lastStickyWrite) return;

    var regular = block.querySelector(".price__regular .price-item--regular");
    var sale = block.querySelector(".price__sale .price-item--sale");
    var compare = block.querySelector(".price__compare-price s.price-item--regular");
    var wrapper = block.querySelector(".price");

    if (regular) regular.textContent = now;
    if (sale) sale.textContent = now;

    if (compare) {
      if (was && variant.compareAt > variant.price) {
        compare.textContent = was;
        compare.parentElement.style.setProperty(
          "display",
          "inline-block",
          "important"
        );
        if (wrapper) wrapper.classList.add("price--on-sale");
      } else {
        compare.parentElement.style.setProperty("display", "none", "important");
        if (wrapper) wrapper.classList.remove("price--on-sale");
      }
    }

    lastStickyWrite = stamp;
  }

  /* ---- find and enhance the Pack fieldset ---- */

  function enhance(prices) {
    var fieldsets = document.querySelectorAll("fieldset.product-form__input");
    var done = false;

    Array.prototype.forEach.call(fieldsets, function (fs) {
      var inputs = fs.querySelectorAll('input[type="radio"][name="Pack"]');
      if (!inputs.length) return;
      if (fs.getAttribute("data-everden-tiers") === "1") {
        done = true;
        return;
      }

      fs.classList.add("everden-tiers");
      fs.setAttribute("data-everden-tiers", "1");

      var legend = fs.querySelector("legend");
      if (legend) legend.textContent = LEGEND;

      Array.prototype.forEach.call(inputs, function (input) {
        var container = input.nextElementSibling;
        if (
          container &&
          container.classList.contains("variant_radio_label_container")
        ) {
          decorate(input, container, prices);
        }
      });

      done = true;
    });

    return done;
  }

  /* ---- run, then keep watching for theme re-renders ---- */

  function run() {
    fetchPrices().then(function (prices) {
      enhance(prices);
      syncSticky();

      document.addEventListener("change", function (e) {
        if (
          e.target &&
          (e.target.name === "Pack" ||
            e.target.name === "Colour" ||
            e.target.classList.contains("sticky-atc__dropdown"))
        ) {
          window.setTimeout(syncSticky, 350);
          window.setTimeout(syncSticky, 1200);
        }
      });

      var target = document.querySelector("main") || document.body;
      var pending = false;

      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          enhance(priceData);
          syncSticky();
        });
      }).observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
